import * as bulkSelection from './bulkSelectionModel'
import * as statementSelectionModel from './statementSelectionModel'

export const combinedSelectedTotalCents = (
  selection: bulkSelection.BulkSelection,
  statementSelection: statementSelectionModel.StatementSelection,
  totalInvoicedCents: number
): number => {
  const invoiceTotal = bulkSelection.selectedTotalCents(selection, totalInvoicedCents)
  if (selection.mode === bulkSelection.BulkSelectionModes.All) {
    return invoiceTotal - statementSelectionModel.excludedStatementTotalCents(statementSelection)
  }
  return invoiceTotal + statementSelectionModel.selectedStatementTotalCents(statementSelection)
}
